import React from 'react';

const isModifierKey = (code) => {
  return [
    'ShiftLeft', 'ShiftRight',
    'ControlLeft', 'ControlRight',
    'AltLeft', 'AltRight',
    'MetaLeft', 'MetaRight'
  ].includes(code);
};

const Key = ({
  keyCode,
  children,
  className = '',
  pressedKeys = new Set(),
  activeModifiers = new Set(),
  size = 'normal',
  tooltipText,
  disabled = false,
  onClick = () => {},
  shiftedKey,
  isShifted = false,
  ...props
}) => {
  const isPressed = pressedKeys.has(keyCode);
  const isActive = activeModifiers.has(keyCode);

  const sizeClass = {
    normal: '',
    long: 'long',
    extra: 'extra-long',
    space: 'space'
  }[size];

  const stateClasses = [
    className,
    sizeClass,
    isPressed ? 'pressed' : '',
    isActive ? 'active-modifier' : '',
    disabled ? 'disabled' : ''
  ].filter(Boolean).join(' ');

  const displayChar = isShifted ? shiftedKey : children;

  return (
    <button
      className={`key ${stateClasses}`}
      data-key-code={keyCode}
      data-shifted-key={shiftedKey}
      onClick={onClick}
      title={tooltipText}
      disabled={disabled}
      {...props}
    >
      <span className='primary'>{displayChar}</span>
      {shiftedKey && (
        <span className='shifted'>{shiftedKey}</span>
      )}
    </button>
  );
};

export default Key;
